import React from "react";
import { Icon, Card, Text, Flex, Button } from "@jsq/ds/core";
import { paymentPrefDisplayCardIcon } from "../PaymentPrefDisplayCardContainer/styles_vanilla.css";
import {
  PositionListBaseComponent,
  type PositionListBaseComponentProps,
} from "../PositionList/PositionListBaseComponent";

export interface InstructionsNeededCardProps extends PositionListBaseComponentProps {
  showAddPayment?: boolean;
  handleCreatePayment?: () => void;
}

export const InstructionsNeededForPositionsCard: React.FC<InstructionsNeededCardProps> = ({
  positionsPaginated,
  fetchMorePositions,
  positionListError,
  positionListLoading,
  showAddPayment = false,
  handleCreatePayment,
}: InstructionsNeededCardProps) => {
  return (
    <Card padding="md">
      <Flex flexDirection="row" justifyContent="flex-start" alignItems="flex-start">
        <Icon
          variant="outline"
          type="plus"
          size="x-large"
          style={{ marginRight: "16px" }}
          data-testid="icon"
          className={paymentPrefDisplayCardIcon}
        />
        <Flex flexDirection="column" gap={16} style={{ width: "100%" }}>
          <Text variant="strong-lg">Instructions needed</Text>
          <PositionListBaseComponent
            positionListError={positionListError}
            positionListLoading={positionListLoading}
            positionsPaginated={positionsPaginated}
            fetchMorePositions={fetchMorePositions}
          />
          {showAddPayment && (
            <Button variant="neutral" isFullWidth onClick={handleCreatePayment}>
              Add payment instructions
            </Button>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};
